<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.content}}</p>
</div>
<div mat-dialog-actions style="text-align: center">
  <mat-progress-bar [mode]="progressType" [value]="progressValue" [style.display]="!showProgress ? 'none' : 'block'"></mat-progress-bar>
  <a mat-button mat-stroked-button href="{{data.url}}" target="_blank" color="primary" [style.display]="showProgress || data.hideOk ? 'none' : 'block'">{{data.buttonName}}</a>
  <a mat-button mat-stroked-button (click)="closeClick()" [style.display]="showProgress ? 'none' : 'block'">Close</a>
</div>
